import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as styles from './styles/popupPortal.css';

export interface IPopupPortalProps extends React.HTMLProps<HTMLElement> {
  children?: React.ReactNode;
  top: number;
  left: number;
  calculateOnScroll?: boolean;
  setRef: React.RefObject<HTMLDivElement | null>;
}

export function PopupPortal({ setRef, children, calculateOnScroll, top = 0, left = 0 }: IPopupPortalProps) {
  const portalNode = getPortalNode();

  // Без контейнера портала попап просто не показываем: throw здесь дошёл бы до корневого
  // error boundary и стёр бы всю страницу.
  if (!children || !portalNode) {
    return null;
  }

  const style = calculateOnScroll ? { transform: `translate3d(${left}px, ${top}px, 0)` } : { top, left };

  const portalWithContainer = (
    <div ref={setRef} data-mark="PopupPortal" className={styles['portal']} style={style}>
      {children}
    </div>
  );

  // Компонент не может вернуть портал как сущность, однако портал может быть обернут во фрагмент
  return React.createElement(React.Fragment, {}, portalize(portalWithContainer, portalNode));
}

function portalize(reactNode: React.ReactNode, portalNode: HTMLElement) {
  return ReactDOM.createPortal(React.Children.only(reactNode), portalNode);
}

function getPortalNode(): HTMLElement | null {
  return document.getElementById('popup_zone');
}
